import * as O from 'fp-ts/Option';
import * as D from './dimension';
import * as F from './finish';
import * as C from './custom';
import * as PF from './productFilters';
export const isFinish = (p) => F.Finish.is(p);
export const isDimension = (p) => D.Dimension.is(p);
export const isCustom = (p) => C.Custom.is(p);
export const isProductFilters = (p) => PF.ProductFilters.is(p);
export const getString = (p) => {
    return p?.toString();
};
export const image = (p) => {
    if (F.Finish.is(p)) {
        return O.some(p.image);
    }
    else {
        return O.none;
    }
};
export const colour = (p) => {
    if (F.Finish.is(p)) {
        return O.some(p.colour);
    }
    else {
        return O.none;
    }
};
export const colourName = (p) => {
    if (F.Finish.is(p)) {
        return O.some(p.name);
    }
    else {
        return O.none;
    }
};
export const compare = (
// TODO: do we need to compare custom config props?
propertiesA, propertiesB) => {
    if (D.Dimension.is(propertiesA.dimension) &&
        D.Dimension.is(propertiesB.dimension) &&
        F.Finish.is(propertiesA.finish) &&
        F.Finish.is(propertiesB.finish)) {
        const dimensionsEqual = D.equal(propertiesA.dimension, propertiesB.dimension);
        if (dimensionsEqual) {
            return F.compare(propertiesA.finish, propertiesB.finish);
        }
        else {
            return D.compare(propertiesA.dimension, propertiesB.dimension);
        }
    }
    else if (D.Dimension.is(propertiesA.dimension) && D.Dimension.is(propertiesB.dimension)) {
        return D.compare(propertiesA.dimension, propertiesB.dimension);
    }
    else if (F.Finish.is(propertiesA.finish) && F.Finish.is(propertiesB.finish)) {
        return F.compare(propertiesA.finish, propertiesB.finish);
    }
    else {
        return 0;
    }
};
